// extracted by mini-css-extract-plugin
export default {"snackbar":"HveVk","snackbar-item":"FRCGB","message":"beyM1"};